module.exports = __webpack_public_path__ + "img/operaciones.43b979a2.svg";